import { OrderPdfStatus } from '../model/order-status.model';

export const ORDER_PDF_POLL_INTERVAL_MS = 4000;

export function isPdfStatusGenerating(
  pdfStatus: string | null | undefined
): boolean {
  const status = pdfStatus?.trim().toUpperCase();
  return status === OrderPdfStatus.PENDING || status === OrderPdfStatus.PROCESSING;
}

export function openPresignedPdfUrl(url: string): void {
  window.open(url, '_blank', 'noopener,noreferrer');
}

/**
 * Dispara la descarga usando un iframe oculto (sin abrir pestaña visible).
 * Requiere URL presignada con Content-Disposition: attachment.
 */
export function triggerAttachmentDownload(presignedUrl: string): void {
  const iframe = document.createElement('iframe');
  iframe.style.cssText =
    'position:fixed;right:0;bottom:0;width:0;height:0;border:0;visibility:hidden';
  iframe.setAttribute('aria-hidden', 'true');
  iframe.src = presignedUrl;
  document.body.appendChild(iframe);

  window.setTimeout(() => {
    iframe.remove();
  }, 120000);
}

export function getOrderPdfTooltip(
  pdfStatus: string | null | undefined
): string {
  const status = pdfStatus?.trim().toUpperCase();

  switch (status) {
    case 'PENDING':
      return 'PDF en generación';
    case 'PROCESSING':
      return 'Generando PDF...';
    case 'GENERATED':
      return 'Ver PDF';
    case 'FAILED':
      return 'Error al generar el PDF';
    default:
      return 'Ver PDF';
  }
}
